import { defineComponent as _defineComponent } from 'vue'
import { LookupTableItem } from "@/types";
import { toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Select',
  props: {
    model: null,
    items: null,
    label: { default: "Select" },
    disabled: { type: Boolean, default: false },
    showClearButton: { type: Boolean, default: true },
    customClasses: { default: "" }
  },
  setup(__props: any) {

const props = __props as { model: LookupTableItem, items: LookupTableItem[], label: string, disabled: boolean, showClearButton: boolean, customClasses: string };


const { model, items, label, showClearButton, customClasses, disabled } =
  toRefs(props);

return { __sfc: true,props, model, items, label, showClearButton, customClasses, disabled }
}

})